<template>
  <div class="user-accounting-details">
    <UserAccoutingItem
      v-if="maxBalance !== 0"
      :numberOne="balance"
      :numberTwo="maxBalance"
      icon="mdi-bank"
      :title="$t('AccountPage.UserAccoutingItem.obligo')"
    />
    <UserAccoutingItem
      v-if="balance !== 0"
      :numberOne="balance"
      icon="mdi-hand-coin"
      :title="$t('AccountPage.UserAccoutingItem.balance')"
    />
    <BaseButton
      :isDisabled="balance == 0"
      paddingTop="10px"
      paddingBottom="10px"
      paddingLeft="20px"
      paddingRight="20px"
      class="w-100"
    >
      <span>{{ $t("AccountPage.UserAccoutingItem.payBillBtn") }}</span>
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "../../UI/BaseButton.vue";
import UserAccoutingItem from "./UserAccoutingItem.vue";
export default {
  components: { UserAccoutingItem, BaseButton },
  props: {
    maxBalance: {
      type: Number,
      default: 0,
    },
    balance: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped lang="scss">
.user-accounting-details {
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;

  border-radius: 10px;
  background: var(--Liter-Grey, #f5f5f5);
}
</style>
